import { useCallback } from "react";

import { UpdateAdminForm } from "~/forms/UpdateAdminForm";
import type { UpdateAdminFormType } from "~/forms/UpdateAdminForm/schema";
import { updateAdmin } from "~/modules/admin/services";
import { authenticationAtom } from "~/modules/authentication/data";
import { updateSessionUser } from "~/modules/authentication/services";
import { useAtom } from "~/observers/jotai";

export function Profile() {
	const [session] = useAtom(authenticationAtom);

	const handleSubmit = useCallback(async (payload: UpdateAdminFormType) => {
		const data = await updateAdmin(payload);
		if (data) {
			updateSessionUser(data);
		}
	}, []);

	return (
		<div className="flex-1 flex p-5 bg-slate-100">
			<div
				className="flex p-4 items-stretch bg-white rounded-lg m-auto
        max-w-[900px] w-full"
			>
				<UpdateAdminForm
					defaultValues={{
						email: session!.user.email,
						name: session!.user.name,
					}}
					onSubmit={handleSubmit}
				/>
			</div>
		</div>
	);
}
